import { render, staticRenderFns } from "./priceLabel.vue?vue&type=template&id=41dfbc95"
import script from "./priceLabel.vue?vue&type=script&lang=js"
export * from "./priceLabel.vue?vue&type=script&lang=js"
import style0 from "./priceLabel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports